import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-c-3-email",
  "use": "icon-c-3-email-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-c-3-email\">\n<rect x=\"2.22218\" y=\"3\" width=\"15.5556\" height=\"14\" rx=\"3.11111\" stroke=\"#6C6B80\" stroke-width=\"1.16667\" />\n<path d=\"M2.2222 6.11108L8.05648 10.7785C9.19272 11.6875 10.8072 11.6875 11.9435 10.7785L17.7778 6.11108\" stroke=\"#6C6B80\" stroke-width=\"1.16667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol